export const INITIAL_FAST_VALUE = 34;
export const INITIAL_FLAT_VALUE = 33;
export const INITIAL_BICYCLE_ADAPTED_VALUE = 33;